export const holidays: Array<{date:string,label:string}> = [{
  date: '2025-01-01',
  label: 'Nyårsdagen',
},{
  date: '2025-01-06',
  label: 'Trettondagen',
},{
  date: '2025-04-18',
  label: 'Långfredagen',
},{
  date: '2025-04-20',
  label: 'Påskdagen',
},{
  date: '2025-04-21',
  label: 'Annandag påsk',
},{
  date: '2025-05-01',
  label: 'Första Maj',
},{
  date: '2025-05-29',
  label: 'Kristi himmelfärdsdag',
},{
  date: '2025-06-06',
  label: 'Sveriges nationaldag',
},{
  date: '2025-06-08',
  label: 'Pingstdagen',  
},{
  date: '2025-06-21',
  label: 'Midsommardagen',
},{
  date: '2025-11-01',
  label: 'All helgons dag',
},{
  date: '2025-12-25',
  label: 'Juldagen',
},{
  date: '2025-12-26',
  label: 'Annandag jul',
}]
